<template>

  <div id="footer-wrapper">

    <div id="address">
      <img id="logo" src="../../assets/logo.svg">
      <p>32 Carpenter Street</p>
      <p>Singapore, 059911</p>
    </div>

    <div id="links">
      <ul>
        <router-link to="/login">
          <li>🔑Login</li>
        </router-link>
        <router-link to="/about">
          <li>👋About</li>
        </router-link>
        <router-link to="/faq">
          <li>⁉️FAQ</li>
        </router-link>
        <router-link to="/pricing">
          <li>💵Pricing</li>
        </router-link>
        <router-link to="/privacy">
          <li>🔒Privacy</li>
        </router-link>
        <router-link to="/terms">
          <li>📜Terms</li>
        </router-link>
      </ul>

      <div>

        <a href="https://twitter.com/outsidevoice_io" target="_blank">
          <img class="social" src="../../assets/landing/twitter.svg">
        </a>
        <a href="https://www.linkedin.com/company/outsidevoice" target="_blank">
          <img class="social" src="../../assets/landing/linkedin.svg">
        </a>
        <img id="copyright" src="../../assets/copyright.svg">

      </div>

    </div>



  </div>


</template>

<script>

import { isMobile, isMobileOnly } from 'mobile-device-detect';

export default {
  name: 'LandingFooter',
  data: function () {
    return {}
  },
  computed: {
    is_mobile() {
      return isMobileOnly;
    }
  },
  methods: {}

}
</script>

<style scoped lang="scss">

#footer-wrapper{
  width: 1050px;
  margin: 0 auto;
  margin-top: 120px;
  margin-bottom: 60px;
  display: flex;
  justify-content: space-between;
  font-family: 'Montserrat', sans-serif;

  #address{
    #logo{
      width: 180px;
      margin-bottom: 15px;
    }
    p{
      display: block;
      color: white;
      margin-bottom: 6px;
      font-size: 13px;
      font-weight: 500;
    }
  }

  #links{
    ul{
      margin-bottom: 25px;
      li{
        display: inline-block;
        font-size: 15px;
        font-weight: 500;
        margin-left: 25px;
        color: white;
        cursor: pointer;
        opacity: .8;
        transition: all 0.2s ease;
        &:hover{
          opacity: 1;
        }
      }
    }
    div{
      img{
        float: right;
      }
      #copyright{
        width: 160px;
        opacity: .7;
      }
      .social{
        height: 22px;
        float: right;
        margin-left: 15px;
        cursor: pointer;
        opacity: .8;
        transition: all 0.2s ease;
        &:hover{
          opacity: 1;
        }
      }
    }
  }

  #copyright{
    width: 120px;
    margin-top: 30px;
    margin: 0 auto;
  }


}

/* Mobile Styles */
@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

#footer-wrapper{
  width: 90%;
  margin-top: 40px;
  flex-direction: column-reverse;

  #address{
    display: none;
  }

  #links{
    ul{
      padding-left: 15px;
      li{
        display: block;
        margin-left: 0px;
        margin-bottom: 15px;
      }
    }
    div{
      img{
        float: left;
      }
    }
  }

  #copyright{
    margin-left: 13px;
  }

}

}


</style>
